import { render, staticRenderFns } from "./202411.vue?vue&type=template&id=ca216c5c&scoped=true&"
import script from "./202411.vue?vue&type=script&lang=js&"
export * from "./202411.vue?vue&type=script&lang=js&"
import style0 from "./202411.vue?vue&type=style&index=0&id=ca216c5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca216c5c",
  null
  
)

export default component.exports